import { cardResource, CardResource, IdArgs } from '@witkac/kartamiejska-resources';
import { Card } from '@witkac/kartamiejska-shared';

import { EntityModule } from '../entity.module';

/**
 * Moduł kart klienta
 *
 * @class ClientCardModule
 * @extends {EntityModule<Card, CardResource>}
 */
class ClientCardsModule extends EntityModule<Card, CardResource> {
  constructor() {
    super(cardResource);
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę kart klienta
       *
       * @param context context
       */
      list: (context: any): Promise<void> =>
        this.resource.cardsById(context.rootState.client.id).then(list => context.commit('saveList', list)),

      /**
       * Blokuje wybraną karte
       *
       * @param context context
       * @param id id karty
       */
      block: (context: any, id: number): Promise<void> =>
        this.resource.deactivate({ id }).then(() => context.dispatch('list')),

      /**
       * Blokuje kartę na określony czas
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<void>}
       */
      timeBlock: (context: any, variables: any): Promise<void> =>
        this.resource.block(variables).then(() => context.dispatch('list')),

      /**
       * Dodaje encję
       *
       * @param context context
       * @param data dane encji
       */
      add: (context: any, data: any): Promise<void> =>
        this.resource
          .add({ profileId: data.profileId, card: { ...data, profileId: undefined } })
          .then(() => context.dispatch('list')),

      /**
       * Tworzenie duplikatu karty
       *
       * @param {*} context
       * @param {string} cardNumber
       * @returns {Promise<void>}
       */
      duplicateCard: (context: any, cardNumber: string): Promise<void> =>
        this.resource.createDuplicate(cardNumber).then(() => context.dispatch('list')),

      /**
       * Zlecenie druku karty
       *
       * @param {*} context
       * @param {{ id: number; collectionPointId: number }} { id, collectionPointId }
       * @returns {Promise<void>}
       */
      printCard: (context: any, { id, collectionPointId }: { id: number; collectionPointId: number }): Promise<void> =>
        this.resource.printCard(id, collectionPointId).then(() => context.dispatch('list')),

      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: (context: any, data: any): Promise<void> =>
        this.resource
          .update(data.id as number, { card: { ...data, profileId: undefined, id: undefined } })
          .then(() => context.dispatch('list')),

      /**
       * Odbiór karty
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<void>}
       */
      collectCard: (context: any, variables: any): Promise<void> =>
        this.resource.collected(variables).then(() => context.dispatch('list')),

      /**
       * Przedłużenie daty ważności karty o rok
       *
       * @param {*} context
       * @param {*} id
       */
      extendExpirationDateByYear: (context: any, id: number) =>
        this.resource.extendExpirationDateByYear(id).then(() => context.dispatch('list')),

      /**
       * Skrócenie daty ważności karty o rok
       *
       * @param {*} context
       * @param {*} id
       */
      reduceExpirationDateByYear: (context: any, id: number) =>
        this.resource.reduceExpirationDateByYear(id).then(() => context.dispatch('list'))
    };
  }
}

export default new ClientCardsModule();
